import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@pulpo/app-config';
import ApiService from './api.service.abstract';
import { MealTranslation } from '@pulpo/pulpo-models';

@Injectable({ providedIn: 'root' })
export class MealTranslationService extends ApiService<MealTranslation> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'api/meal-translations');
  }

  findForMeal(id: number): Observable<HttpResponse<MealTranslation[]>> {
    return this.http.get<MealTranslation[]>(
      `${this.url}/${this.endpoint}/meal?mealId=${id}`,
      { observe: 'response' }
    );
  }
}
